























































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";

const Applicants = namespace("applicant");
@Component({})
export default class Applicant extends Vue {
  @Applicants.Action("fetchCurrentApplicant")
  fetchCurrentApplicant!: (applicantId: string) => Promise<{}>;
  @Applicants.Getter("currentApplicant") applicant: Applicant;

  @Prop({ default: false }) readonly isOwner!: boolean;

  mounted() {
    const applicantId = this.$route.params.applicantId;
    this.fetchCurrentApplicant(applicantId).catch((err) => {
      console.log(err.message);
    });
  }
  capitalizeFirstLetter(value: string) {
    value = value.toLowerCase();
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
  goBack() {
    this.$router.go(-1);
  }
}
